module.exports = __webpack_public_path__ + "img/selected2-min.66b0074f.png";